// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ctm-tools[data-v-681d993f]{padding:24px;background:#f8f9fa;min-height:100vh}.ctm-tools__header[data-v-681d993f]{margin-bottom:24px}.ctm-tools__title[data-v-681d993f]{font-size:22px;font-weight:600;color:#1e1f21;margin:0 0 4px;line-height:1.3}.ctm-tools__subtitle[data-v-681d993f]{color:#6b7280;font-size:13px;margin:0}.ctm-tools__body[data-v-681d993f]{background:#fff;border-radius:10px;box-shadow:0 1px 4px rgba(30,31,33,.08);overflow:hidden;padding:0 24px 24px}", ""]);
// Exports
module.exports = exports;
